import React from 'react';

import { useQuery } from "react-query";

// see : https://tanstack.com/query/latest/docs/react/guides/paginated-queries
// see:  https://tanstack.com/query/v3/docs/react/guides/paginated-queries

import { fetchClientsAdministration } from 'utils/queries';
import { getConfigAutorisationRemboursementEnMagasin, getConfigChargerContact } from 'utils/clientHelper';


import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TablePagination from '@mui/material/TablePagination';


import ClientPrioritaireIcon from '@mui/icons-material/WarningTwoTone';
import LensIcon from '@mui/icons-material/Lens';

import Datetime from 'components/Shared/Datetime';
//import TriStateFilter from 'components/Shared/TriStateFilter';


const reglementTypes = ['Comptant', ' En compte', 'Carte achat']; // TODO obtenir depuis une requête

const marcheTypes = ['Hors marché', 'Privé', 'Public'];


const AdministrationClientsTable = () => {

    const [page, setPage] = React.useState(0);
    const [nbParPage, setNbParPage] = React.useState(10);

    const [filtreCode, setFiltreCode] = React.useState('');

    const [filtreReglementType, setFiltreReglementType] = React.useState('');
    const [filtreMarcheType, setFiltreMarcheType] = React.useState('');
    const [filtrePrioritaire, setFiltrePrioritaire] = React.useState('');
    const [filtreChargerContact, setFiltreChargerContact] = React.useState('');


    const { isLoading, isError, error, data } =
        useQuery({
            queryKey: [
                'clientsTable',
                page,
                nbParPage,
                filtreCode,
                filtreReglementType,
                filtreMarcheType,
                filtrePrioritaire,
                filtreChargerContact
            ],
            queryFn: () => fetchClientsAdministration({
                page,
                nbParPage,
                filtreCode,
                filtreReglementType,
                filtreMarcheType,
                filtrePrioritaire: filtrePrioritaire === '' ? null : filtrePrioritaire === 'true',
                filtreChargerContact: filtreChargerContact === '' ? null : filtreChargerContact === 'true'
            }),
            keepPreviousData: true,
        })


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setNbParPage(+event.target.value);
        setPage(0);
    };


    React.useEffect(() => {
            setPage(0);
        },
        [filtreCode, filtreReglementType, filtreMarcheType, filtrePrioritaire, filtreChargerContact]
    );

    return (
        <>
            <Typography gutterBottom variant="h5">
                Visualisation des clients
            </Typography>


            {isLoading ? (
                <div>Chargement...</div>
            ) : isError ? (
                <div>Erreur: {error.message}</div>
            ) : (
                <span></span>
            )}

            <Paper>

                {data ? (
                    <TableContainer sx={{ maxHeight: '100%' }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Code</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Nom</TableCell>

                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Prioritaire</TableCell>

                                    <TableCell sx={{ backgroundColor: 'lightslategrey', textAlign: 'center' }}>Charger contact</TableCell>

                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Etat</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>FacturationMode</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>ReglementType</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Blocage</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>MarcheType</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey', textAlign: 'center' }}>Type de remboursement</TableCell>

                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Dernière livraison</TableCell>


                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ width: '120px' }}>
                                        <TextField
                                            value={filtreCode}
                                            onChange={e => { setFiltreCode(e.target.value) }}
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                    </TableCell>

                                    <TableCell sx={{ width: '120px' }}>
                                        <TextField
                                            select
                                            fullWidth
                                            value={filtrePrioritaire}
                                            onChange={e => { setFiltrePrioritaire(e.target.value) }}
                                        >
                                            <MenuItem key="all" value={''}>{"Tous"}</MenuItem>
                                            <MenuItem key="oui" value={'true'}>{"Oui"}</MenuItem>
                                            <MenuItem key="non" value={'false'}>{"Non"}</MenuItem>
                                        </TextField>
                                    </TableCell>

                                    <TableCell sx={{ width: '120px' }}>
                                        <TextField
                                            select
                                            fullWidth
                                            value={filtreChargerContact}
                                            onChange={e => { setFiltreChargerContact(e.target.value) }}
                                        >
                                            <MenuItem key="all" value={''}>{"Tous"}</MenuItem>
                                            <MenuItem key="actif" value={'true'}>{"Actif"}</MenuItem>
                                            <MenuItem key="exclu" value={'false'}>{"Exclu"}</MenuItem>
                                        </TextField>
                                    </TableCell>

                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell>
                                        <TextField
                                            select
                                            value={filtreReglementType}
                                            onChange={e => { setFiltreReglementType(e.target.value) }}
                                        >

                                            <MenuItem key={-1} value={''}>
                                                {""}
                                            </MenuItem>
                                            {reglementTypes.map((type, index) => (
                                                <MenuItem key={index} value={index}>
                                                    {type}
                                                </MenuItem>
                                            ))}

                                        </TextField>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell>
                                        <TextField
                                            select
                                            value={filtreMarcheType}
                                            onChange={e => { setFiltreMarcheType(e.target.value) }}
                                        >

                                            <MenuItem key={-1} value={''}>
                                                {"N/A"}
                                            </MenuItem>
                                            {marcheTypes.map((type, index) => (
                                                <MenuItem key={index} value={index}>
                                                    {type}
                                                </MenuItem>
                                            ))}

                                        </TextField>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data.clients
                                    .map((client) => {
                                        return (
                                            <TableRow hover key={`${client.id}`}>
                                                <TableCell sx={{ maxWidth: '100px' }}>{client.code}</TableCell>
                                                <TableCell>{client.libelle}</TableCell>

                                                <TableCell>{client.prioritaire && (<ClientPrioritaireIcon />)}</TableCell>

                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    {(() => {
                                                        const config = getConfigChargerContact(client.chargerContactExclusionMotif);
                                                        return (
                                                            <Tooltip title={config.message} arrow>
                                                                <LensIcon sx={{ color: config.color, fontSize: '1.2rem' }} />
                                                            </Tooltip>
                                                        );
                                                    })()}
                                                </TableCell>

                                                <TableCell>{client.etat}</TableCell>
                                                <TableCell>{client.facturationMode}</TableCell>
                                                <TableCell>{reglementTypes[client.reglementType]}</TableCell>
                                                <TableCell>{client.blocage}</TableCell>
                                                <TableCell>{marcheTypes[client.marcheType]}</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    {client.autorisationRemboursementEnMagasin !== undefined && client.autorisationRemboursementEnMagasin !== null ? (
                                                        (() => {
                                                            const config = getConfigAutorisationRemboursementEnMagasin(client.autorisationRemboursementEnMagasin);
                                                            return (
                                                                <Tooltip title={config.message} arrow>
                                                                    <LensIcon sx={{ color: config.color, fontSize: '1.2rem' }} />
                                                                </Tooltip>
                                                            );
                                                        })()
                                                    ) : (
                                                        <Tooltip title="Non défini" arrow>
                                                            <LensIcon sx={{ color: '#9c27b0', fontSize: '1.2rem' }} />
                                                        </Tooltip>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {client.dateLivraisonDernierePieceGestion !== null && (<Datetime datetime={client.dateLivraisonDernierePieceGestion} />)}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>

                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={data.nbFiltres}
                            rowsPerPage={nbParPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                ) : <span>...</span>
                }

            </Paper>


        </>

        );

};





//AdministrationClientsTable.propTypes = {
//};

export default AdministrationClientsTable;